import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

import useSize from "../../../Utils/useSize/useSize";
import Backend from "../../../Backend/Backend";

import TopHeader from "./TopHeader";
import HeaderAccount from "./HeaderAccount";
import MiniHeader from "./MiniHeader";
import StandingCard from "./StandingCard/StandingCard";
import Loading from "../../../Utils/Loading/Loading";
import NotFound from "../../../Utils/NotFound/NotFound";

const backend = await new Backend().init();

export default function Standing() {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDollar, setIsDollar] = useState(0);
  const windowSize = useSize();
  const dispatch = useDispatch();

  // 🧩 Build user credentials
  const getUserData = useCallback(
    () => ({
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
    }),
    []
  );

  // 🔄 Fetch standing data
  const loadStanding = useCallback(async () => {
    setLoading(true);
    try {
      const data = getUserData();
      const res = await backend.standing(data);

      if (res?.error === "False" && Array.isArray(res.standing)) {
        setPositions(res.standing);
        setIsDollar(res.isDollar);
        dispatch({ type: "CLEAR_PF" });
      } else {
        if (res?.logout === 1) {
          window.LogOut?.();
        } else {
          toast.error(res?.message || "Failed to load standing data.");
        }
      }
    } catch (err) {
      console.error("Standing Load Error:", err);
      toast.error("Something went wrong while loading standing data.");
    } finally {
      setLoading(false);
    }
  }, [getUserData, dispatch]);

  // 🧭 Initial load
  useEffect(() => {
    loadStanding();
  }, [loadStanding]);

  // 📱 Dynamic height values
  const contentHeight = windowSize[1] - 260;

  return (
    <div className="bg-[var(--background)] overflow-hidden">
      {/* Header */}
      <TopHeader isDollar={isDollar} />

      <HeaderAccount isDollar={isDollar} />

      {/* Divider */}
      <div className="border-t border-[var(--hover)]" />

      {/* Main Content */}
      <div className="px-5 py-3">
        <MiniHeader  reload={loadStanding} />
        <div
          key={loading ? "loading" : "loaded"}
          style={{
            height: contentHeight,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading ? (
            <div className="flex items-center justify-center w-full h-full">
              <Loading height={contentHeight} />
            </div>
          ) : positions.length > 0 ? (
            <div
              className="overflow-y-auto custom-scrollbar"
              style={{
                height: contentHeight,
                overflowY: "scroll",
                scrollBehavior: "smooth",
                paddingBottom: 200,
              }}
            >
              {positions.map((item, index) => (
                <StandingCard
                  key={item.id || index}
                  item={item}
                  index={index + 1}
                  total={positions.length}
                  isDollar={isDollar}
                />
              ))}
            </div>
          ) : (
            <NotFound
              small
              height={contentHeight}
              title="Nothing here"
              subtext="No standing found."
            />
          )}
        </div>
      </div>
    </div>
  );
}
